import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

const updateDarkMode = (prefersDarkMode: boolean) => {
  if (prefersDarkMode) {
    document.querySelector('html')?.classList.add('dark');
  } else {
    document.querySelector('html')?.classList.remove('dark');
  }
};

export const useTheme = () => {
  const pathname = usePathname();

  useEffect(() => {
    const url = new URL(location.href);
    const bg = url.searchParams.get('bg') || sessionStorage.getItem('bg');

    const body = document.querySelector('body');

    if (bg && body) {
      sessionStorage.setItem('bg', bg);
      body.style.backgroundColor = `#${bg}`;
    }
  });

  useEffect(() => {
    const url = new URL(location.href);
    const theme =
      url.searchParams.get('theme') || sessionStorage.getItem('theme');

    if (theme) {
      sessionStorage.setItem('theme', theme);
      updateDarkMode(theme !== 'light');
      return;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => updateDarkMode(mediaQuery.matches);

    updateDarkMode(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [pathname]);
};
